import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchUpdateMaterial } from "./learningAPI";
import swal from 'sweetalert';
export interface DocumentMState {
  updateMaterial: Array<any>;
  status: "idle" | "loading" | "failed";
}

const initialState: DocumentMState = {
    updateMaterial: [],
  status: "idle",
};

export const GetUpdateMaterial = createAsyncThunk(
  "UpdateMaterial/fetchUpdateMaterial",
  async (data:any) => {
    const response = await fetchUpdateMaterial(data);
    return response;
  }
);

export const UpdateMaterialSlice = createSlice({
  name: "UpdateMaterial",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetUpdateMaterial.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetUpdateMaterial.rejected, (state) => {
        state.status = "failed";
        swal("Something went wrong!",  "error");
      })
      .addCase(GetUpdateMaterial.fulfilled, (state, action) => {
        state.status = "idle";
        state.updateMaterial = action.payload;
        swal("Record updated success!",  "success");
      });
  },
});

export const {} = UpdateMaterialSlice.actions;

export const selectUpdateMaterial = (state: RootState) => {
  return state.UpdateMaterial.updateMaterial;
};

export default UpdateMaterialSlice.reducer;
